module.exports = __webpack_public_path__ + "media/reskin-images/icon--al-logo-aec16dd6.svg";